<template>
  <v-container>
    <v-row justify="space-between" dense>
      <v-row align="start" justify="center">
        <v-col cols="12">
          <v-card class="elevation-2">
            <title-bar></title-bar>
            <v-card-title class="primary--text text-h6 pl-4 font-weight-bold"
              >REFERENCES</v-card-title
            >
            <v-card-text>(please provide three references)</v-card-text>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <span v-for="index in 3" :key="index">
                  <v-card class="mb-3" v-if="index == 1 || ref[index - 1].name">
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" md="4" lg="3">
                          <v-text-field
                            v-model="ref[index].name"
                            prepend-inner-icon="mdi-account-arrow-right-outline"
                            label="Name *"
                            :rules="requiredRules"
                            filled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" lg="3">
                          <v-text-field
                            v-model="ref[index].phone"
                            :rules="phoneRules"
                            label="Phone Number"
                            prepend-inner-icon="phone_iphone"
                            v-mask="'(###)###-####'"
                            filled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-text-field
                            v-model="ref[index].length"
                            label="Length of relationship *"
                            :rules="requiredRules"
                            placeholder
                            filled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" lg="2">
                          <v-text-field
                            v-model="ref[index].relationship"
                            label="Relationship to you *"
                            :rules="requiredRules"
                            filled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2" lg="2">
                          <v-select
                            v-model="ref[index].type"
                            :items="ref_types"
                            item-text="name"
                            item-value="key"
                            menu-props="auto"
                            label="Type *"
                            :rules="requiredRules"
                            hide-details
                            single-line
                            filled
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </span>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="secondary" @click="previous">Previous</v-btn>
              <v-btn class="mr-5" color="primary" @click="formSubmit"
                >Next</v-btn
              >
            </v-card-actions>
            <footer-bar></footer-bar>
          </v-card>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import TitleBar from "../components/TitleBar";
import FooterBar from "../components/Footer";

export default {
  components: { TitleBar, FooterBar },

  computed: {
    ref: {
      get() {
        return this.$store.state.ref;
      },
      set(value) {
        this.$store.commit("setRef", { ref: value });
      },
    },
    app_state: {
      get() {
        return this.$store.state;
      },
    },
  },

  data: () => ({
    requiredRules: [(v) => !!v || "This field is required"],
    phoneRules: [
      (v) => !!v || "Phone is required",
      (v) =>
        /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(
          v
        ) || "Phone must be valid",
    ],
    valid: false,
    loading: true,
    ref_types: [
      { name: "School", key: "School" },
      { name: "Work", key: "Work" },
      { name: "Personal", key: "Personal" },
    ],
  }),
  props: {
    source: String,
  },

  methods: {
    formSubmit(e) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.$router.push({ name: "P6" });
      }
    },
    previous(e) {
      e.preventDefault();
      this.$router.push({ name: "P4" });
    },
  },

  /* beforeRouteLeave (to, from , next) {
    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  }*/
};
</script>
